<template>
  <div style="position: relative;">
    <div
      v-if="loading"
      :style="{
        background: color,
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        position: 'absolute',
        padding: 0,
        'z-index': zIndex,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }"
    >
      <loader />
    </div>
    <slot />
  </div>
</template>

<script>
import loader from '@/elements/loader.vue';

export default {
  components: {
    loader,
  },
  props: {
    loading: {
      type: Boolean,
    },
    color: {
      type: String,
      default: '#ffffff8a',
    },
    zIndex: {
      type: Number,
      default: 5,
    },
  },
};
</script>
